/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 24.07.13, 09:47
 *
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */


import { BasicCommandVO } from "../BasicCommandVO";

export class BasicC2SRegisterUserVO extends BasicCommandVO {
    public username: string;
    public email: string;
    public password: string;
    public accountId: string;
    public ggsLanguageCode: string;
    public referrer: string;
    public distributorId: number;
    public connectionTime: number;
    public roundTripTime: number;

    // Contains a semicolon separated String with all campaign data
    public campaignVars: string;
    /** Additional campaign vars which aren't part of the campaignVars string **/
    // aid, var_7
    public campaignVars_adid: string;
    // lp, var_6
    public campaignVars_lp: string;
    // creative, var_4
    public campaignVars_creative: string;
    // pid (partnerId), var_3
    public campaignVars_partnerId: string;

    public timezone: number;
    public campaignVars_websiteId: string;

    public initialize(): void {
        // override
    }
}
